import * as React from "react";
import { styled } from "@mui/system";
import MUIModal from "@mui/material/Modal";
import { ModalProps as ModalPropsMUI, ModalTypeMap } from "@mui/material/Modal";
import { OverridableComponent } from "@mui/material/OverridableComponent";
export interface ModalProps extends ModalPropsMUI {
  component?: React.ElementType;
}

const ModalRoot = styled(MUIModal, {
  name: "Modal",
  slot: "Root",
  overridesResolver: (props, styles) => []
})(({ theme }) => ({}));

export const Modal = React.forwardRef<HTMLDivElement, ModalProps>(
  function Modal(props, ref) {
    return <ModalRoot {...props} ref={ref} />;
  }
) as OverridableComponent<ModalTypeMap<"div", {}>>;
